module.exports = __webpack_public_path__ + "img/swift-sport-2021.ee66a8af.svg";